"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = require("@xstate/react");
const react_2 = __importStar(require("react"));
const AnimationContainer_1 = require("../../../components/LayoutFactory/AnimationContainer");
const DesktopLayout_1 = __importDefault(require("../../../components/LayoutFactory/DesktopLayout"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const useLayoutAnimation_1 = require("../../../hooks/useLayoutAnimation");
const RescheduleFlowMobileLayout_1 = require("../../../components/LayoutFactory/RescheduleFlowMobileLayout");
const MemoizedProviderSidebar_1 = __importDefault(require("../../../components/Sidebar/MemoizedProviderSidebar"));
const AppointmentWaitlistLayout = ({ service, renderChildren }) => {
    const [headerHeight] = (0, react_2.useState)(0);
    const [state] = (0, react_1.useService)(service);
    const { context } = state;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const { direction, isAnimating: bodyIsAnimating, onAnimationComplete, onAnimationStart } = (0, useLayoutAnimation_1.useLayoutAnimation)();
    // Using MemoizedProviderSidebar component instead of local implementation
    const sidebar = context.provider ? (react_2.default.createElement(MemoizedProviderSidebar_1.default, { provider: context.provider, appointment: context.waitlist.original_appointment, appointmentQuery: context.appointmentQuery, showAppointmentId: false })) : null;
    if (aboveMd) {
        return (react_2.default.createElement(DesktopLayout_1.default, { sidebar: sidebar, header: react_2.default.createElement(react_2.default.Fragment, null), footer: react_2.default.createElement(react_2.default.Fragment, null) },
            react_2.default.createElement(AnimationContainer_1.AnimationContainer, { direction: direction.current, onAnimationComplete: onAnimationComplete, state: state.value.toString(), onAnimationStart: onAnimationStart }, renderChildren(headerHeight, bodyIsAnimating))));
    }
    return (react_2.default.createElement(AnimationContainer_1.AnimationContainer, { direction: direction.current, onAnimationComplete: onAnimationComplete, state: state.value.toString(), onAnimationStart: onAnimationStart },
        react_2.default.createElement(RescheduleFlowMobileLayout_1.RescheduleFlowMobileLayout, { sidebar: sidebar, banner: null, isErrorOrRescheduled: false, footer: null }, renderChildren(headerHeight, bodyIsAnimating))));
};
exports.default = AppointmentWaitlistLayout;
//# sourceMappingURL=AppointmentWaitlistLayout.js.map